import Backbone from 'backbone';
import _ from 'underscore';

//noinspection UnnecessaryLocalVariableJS
const CalendarTileView = Backbone.View.extend({

    tagName: 'div',
    className: 'calendar-month-view-tile',
    adjacentClassName: 'calendar-month-view-tile-adjacent',
    todayClassName: 'calendar-month-view-tile-today',
    focusedClassName: 'calendar-month-view-tile-focus',
    disabledClassName: 'calendar-month-view-tile-disabled',

    date: null,
    adjacent: false,

    template: _.template('<span><%- date.getDate() %></span>', null, {variable: 'date'}),

    initialize: function (options) {
        const that = this;

        options = options || {};
        this.date = options.date;
        this.adjacent = !!options.adjacent;

        this.$el.on('click', function (event) {
            that.trigger('click', that);
            event.stopPropagation();
            event.preventDefault();
        });

        return this;
    },

    render: function () {

        this.el.role = 'gridcell';

        if (this.date) {
            this.$el.html(this.template(this.date));
            let className = this.className;
            if (this.adjacent) {
                className += ' ' + this.adjacentClassName;
            }
            if (this.focused) {
                className += ' ' + this.focusedClassName;
            }
            if (this.disabled) {
                className += ' ' + this.disabledClassName;
            }
            const now = new Date();
            if (this.date.getFullYear() === now.getFullYear() &&
                this.date.getMonth() === now.getMonth() &&
                this.date.getDate() === now.getDate()) {
                className += ' ' + this.todayClassName;
            }
            this.el.className = className;
        }
        return this;
    },

    setDate: function (/** Date */date, /** boolean */isAdjacent, /** boolean= */render) {
        this.adjacent = !!isAdjacent;
        this.date = date;
        if (render) this.render();
        return this;
    },

    getDate: function () {
        return this.date;
    },

    setDisabled: function (/** boolean */disabled, /** boolean= */render) {
        this.disabled = !!disabled;
        if (render) this.render();
        return this;
    },

    getDisabled: function () {
        return this.disabled;
    },

    isAdjacent: function () {
        return this.adjacent;
    },

    setFocused: function (focused) {
        this.focused = focused || focused === undefined;
        return this;
    }

});

export default CalendarTileView;
